/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from 'react-intl';
import { SidebarMenuItem } from './SidebarMenuItem';
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub';
import DashboardSVG from "../../../../../_uLearn/assets/media/dashboard/dashboard.svg";
import MasterSVG from "../../../../../_uLearn/assets/media/dashboard/master.svg";
import ActivitySVG from "../../../../../_uLearn/assets/media/dashboard/activityConfig.svg";
import SchoolSVG from "../../../../../_uLearn/assets/media/dashboard/school.svg";
import TeacherSVG from "../../../../../_uLearn/assets/media/dashboard/teacher.svg";
import StudentSVG from "../../../../../_uLearn/assets/media/dashboard/student.svg";
import VendorSVG from "../../../../../_uLearn/assets/media/dashboard/vendor.svg";
import AboutUsSVG from "../../../../../_uLearn/assets/media/dashboard/info.svg";
import PrivacySVG from "../../../../../_uLearn/assets/media/dashboard/privacyPolicy.svg";
import TermsConditionsSVG from "../../../../../_uLearn/assets/media/dashboard/termsConditions.svg";
import AppSettingsSVG from "../../../../../_uLearn/assets/media/dashboard/appSettings.svg";
// import APICallService from "../../../../../api/apiCallService";
// import {DASHBOARD} from "../../../../../api/apiEndPoints";
import { SidebarTitle } from '../../../../../utils/string';
const SidebarMenuMain = () => {
  return (
    <>
      <SidebarMenuItem
        to="/dashboard"
        icon={DashboardSVG}
        title={SidebarTitle.Dashboard}
        fontIcon="bi-app-indicator"
      />
      <SidebarMenuItemWithSub
        to="#"
        icon={MasterSVG}
        title={SidebarTitle.Master}
        fontIcon="bi-app-indicator"
      >
        <SidebarMenuItem
          to="/master/vendor-category"
          // to="/master/vendor"
          title={SidebarTitle.Vendor}
          hasBullet={false}
        />
        <SidebarMenuItem
          to="/master/age-group"
          title={SidebarTitle.Age}
          hasBullet={false}
        />
        <SidebarMenuItem
          to="/master/class-subject"
          title={SidebarTitle.Class}
          hasBullet={false}
        />
        <SidebarMenuItem
          to="/master/academic-years"
          title={SidebarTitle.Academic}
          hasBullet={false}
        />
      </SidebarMenuItemWithSub>
      <SidebarMenuItem
        to="all-activity"
        icon={ActivitySVG}
        title={SidebarTitle.Activity}
        fontIcon="bi-app-indicator"
      />
      <SidebarMenuItem
        to="/all-schools"
        icon={SchoolSVG}
        title={SidebarTitle.Schools}
        fontIcon="bi-app-indicator"
      />
      <SidebarMenuItem
        to="/teachers"
        icon={TeacherSVG}
        title={SidebarTitle.Teachers}
        fontIcon="bi-app-indicator"
      />
      <SidebarMenuItem
        to="/students"
        icon={StudentSVG}
        title={SidebarTitle.Students}
        fontIcon="bi-app-indicator"
      />
      <SidebarMenuItem
        to="/vendors"
        icon={VendorSVG}
        title={SidebarTitle.Vendors}
        fontIcon="bi-app-indicator"
      />
      <SidebarMenuItem
        to="/cms-pages/about-us"
        icon={AboutUsSVG}
        title={SidebarTitle.AboutUs}
        fontIcon="bi-app-indicator"
      />
      <SidebarMenuItem
        to="/cms-pages/privacy-policy"
        icon={PrivacySVG}
        title={SidebarTitle.Privacy}
        fontIcon="bi-app-indicator"
      />
      <SidebarMenuItem
        to="/cms-pages/terms-conditions"
        icon={TermsConditionsSVG}
        title={SidebarTitle.Terms}
        fontIcon="bi-app-indicator"
      />
      <SidebarMenuItem
        to="/appSettings"
        icon={AppSettingsSVG}
        title={SidebarTitle.AppSettings}
        fontIcon="bi-app-indicator"
      />
    </>
  );
};
export { SidebarMenuMain };
